export const partnerReferralTypes = Object.freeze({
  revenueShare: 'REVENUE_SHARE',
  discount: 'DISCOUNT',
});

export const billingOptionsRadios = Object.freeze({
  name: 'billingPreference',
  title: 'Select client billing preference',
  description: 'Receive a revenue share or offer a discount.',
  values: {
    [partnerReferralTypes.revenueShare]: {
      title: 'Revenue share based referral',
      description:
        'You’ll receive a 25% commission on each subscriber. Commission from lending is as per your contract.',
    },
    [partnerReferralTypes.discount]: {
      title: 'Offer discount to your client',
      description:
        'Your client will receive a 25% discount on their selected plan courtesy of you.',
    },
  },
});
